import ApiService from './ApiService'

class EmailService {
  static async getEmails () {
    return ApiService.GET('/api/emails/index')
  }

  static async getEmail (code) {
    return ApiService.GET(`/api/emails/edit/${code}.json`)
  }

  static async saveEmail (code, data) {
    return ApiService.POST(`/api/emails/edit/${code}.json`, data)
  }
}

export default EmailService
